module.exports = __webpack_public_path__ + "media/assets/FariaOne-icon-dc7fd64d021c447b2e53a8b1ff60a2fcbebc653ef2efd12ca72b0c6e4b692f2a.png";